import { createTransport } from '../http/transport'
import { normalizeBaseUrl, type LiteLlmConnection } from './config'

export interface LiteLlmModel {
  /** Model name as the proxy exposes it — send this as `model`. */
  id: string
  ownedBy?: string
}

interface WireModelList {
  data?: { id?: string; owned_by?: string }[]
}

/**
 * Models the given Virtual Key may call. LiteLLM filters `/v1/models` by the
 * key's `models` allow-list, so this doubles as the connection test: a wrong
 * key fails with `unauthorized`, a wrong URL with `network`/`not_found`.
 */
export async function listLiteLlmModels(conn: LiteLlmConnection): Promise<LiteLlmModel[]> {
  const t = createTransport({
    baseUrl: normalizeBaseUrl(conn.baseUrl),
    getAccessToken: async () => conn.virtualKey,
    fetch: conn.fetch,
    timeoutMs: conn.timeoutMs ?? 15_000,
    onError: conn.onError,
  })
  const res = await t.json<WireModelList>('GET', 'v1/models')
  return (res.data ?? [])
    .flatMap((m) => (m.id ? [{ id: m.id, ownedBy: m.owned_by }] : []))
    .sort((a, b) => a.id.localeCompare(b.id))
}
